var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-view__cell active"},[_c('div',{staticClass:"grid-field-rating"},[_c('Rating',{attrs:{"read-only":_vm.readOnly,"rating-style":_vm.field.style,"color":_vm.field.color,"value":_vm.value,"max-value":_vm.field.max_value},on:{"update":_vm.update}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }